<template>
  <v-expansion-panels
    v-model="panels"
    multiple
    accordion
    flat
  >
    <v-expansion-panel :disabled="!Object.keys(selectedInfos).length">
      <v-expansion-panel-header class="text-h6">
        <!-- <v-icon>mdi-selection-marker</v-icon> -->
        Sélection
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <selected-infos />
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel v-if="config.colors.type !== 'none'">
      <v-divider />
      <v-expansion-panel-header class="text-h6">
        Légende
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <map-legend :dense="windowHeight < 600" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import SelectedInfos from './sections/selected-infos.vue'
import MapLegend from './sections/map-legend.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    SelectedInfos,
    MapLegend
  },
  data: () => ({
    panels: []
  }),
  computed: {
    ...mapState(['selectedInfos']),
    ...mapGetters(['config'])
  },
  watch: {
    selectedInfos (value) {
      if (Object.keys(value).length) {
        const array = [0]
        if (this.panels.includes(1)) array.push(1)
        this.panels = array
      } else this.panels = this.panels.filter(v => v)
    }
  },
  mounted () {
    this.panels = [1]
  }
}
</script>

<style lang="css" >
.v-expansion-panel-content__wrap {
  padding: 0 12px 12px!important;
}
</style>
